import { render, staticRenderFns } from "./DeliveryCompanySelect.vue?vue&type=template&id=38d0a8ae&lang=pug"
import script from "./DeliveryCompanySelect.vue?vue&type=script&lang=js"
export * from "./DeliveryCompanySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports